import { render, staticRenderFns } from "./AplifisaFiscal.vue?vue&type=template&id=6ab4a5bc&"
import script from "./AplifisaFiscal.vue?vue&type=script&lang=js&"
export * from "./AplifisaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports